import {
  shadowColor,
  shadowGeometry,
  type ShadowLevel,
  type ShadowGeometry,
} from "../primitives/shadows";

interface ElevationGeometryOptions {
  includeColour?: boolean;
}

interface ColouredElevationGeometry extends ShadowGeometry {
  shadowColor: string;
}

export function elevationGeometry(
  level: ShadowLevel,
  options: { includeColour: true }
): ColouredElevationGeometry;
export function elevationGeometry(level: ShadowLevel): ShadowGeometry;
export function elevationGeometry(
  level: ShadowLevel,
  options: ElevationGeometryOptions = {}
): ShadowGeometry | ColouredElevationGeometry {
  return options.includeColour
    ? { ...shadowGeometry[level], shadowColor }
    : shadowGeometry[level];
}
export type { ShadowLevel };

/** Render a shadow level as a CSS `box-shadow` value. */
export const toBoxShadow = (level: ShadowLevel): string => {
  if (level === "none") return "none";
  const { offsetY, opacity, blur } = shadowGeometry[level];
  return `0 ${offsetY}px ${blur}px rgba(0, 0, 0, ${opacity})`;
};

export const elevation = {
  /** Subtle lift — cards, list items */
  low: toBoxShadow("low"),

  /** Moderate lift — modals, sheets */
  medium: toBoxShadow("medium"),

  /** Strong lift — FABs, popovers */
  high: toBoxShadow("high"),
} satisfies Record<Exclude<ShadowLevel, "none">, string>;

export type Elevation = typeof elevation;
export type ElevationLevel = keyof Elevation;
